import { Box, Divider, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FormattedMessage } from 'react-intl';
import { Roi } from '~/domain/dicom/dicomstructureset';
import { DoseMatrix } from '~/domain/patient/doseMatrix';
import { StructureSet } from '~/domain/patient/structureset';
import DoseConfirmation from './DoseConfirmation';
import StructureSetConfirmation from './StructureSetConfirmation';

type ExportConfirmationProps = {
    open: boolean;
    setOpen: (open: boolean) => void;
    onConfirm: () => void;
    selectedStructureSets: StructureSet[];
    selectedDoses: DoseMatrix[];
    structureSelections: Record<string, Roi[]>;
};

export default function ExportConfirmation({
    open,
    setOpen,
    onConfirm,
    selectedStructureSets,
    selectedDoses,
    structureSelections,
}: ExportConfirmationProps) {
    const handleClose = () => {
        setOpen(false);
    };

    const hasDose = selectedDoses.length > 0;
    const hasStructureSet = selectedStructureSets.length > 0;

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperProps={{ elevation: 0 }}
            fullWidth
        >
            <DialogTitle>
                <FormattedMessage id="confirmDICOMExport" />
            </DialogTitle>
            <DialogContent sx={{ display: 'grid', gap: 2, pb: 1 }}>
                <Typography fontSize={14}>
                    You are about to export the selected datasets through DICOM.
                    Are you sure you want to proceed?
                </Typography>
                {hasStructureSet && (
                    <StructureSetConfirmation
                        selectedStructureSets={selectedStructureSets}
                        structureSelections={structureSelections}
                    />
                )}
                {hasDose && (
                    <>
                        {hasStructureSet && (
                            <Divider flexItem orientation="horizontal" />
                        )}
                        <DoseConfirmation selectedDoses={selectedDoses} />
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Box display="flex" gap={1}>
                    <Button onClick={handleClose}>
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button onClick={onConfirm} autoFocus>
                        <FormattedMessage id="confirm" />
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
}
